import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MainPermissionGuard } from '../../_shared/guards/main-permission-guard.service';
import { CallStatusEditorComponent } from './call-status-editor/call-status-editor.component';
import { CallStatusListComponent } from './call-status-list/call-status-list.component';

const routes: Routes = [
  {
    path:     'call-statuses',
    children: [
      {path: '', canActivate: [MainPermissionGuard], component: CallStatusListComponent},
      {
        path:        'create',
        canActivate: [MainPermissionGuard],
        component:   CallStatusEditorComponent,
        data:        {editor: 'create'},
      },
      {
        path:        ':id/edit',
        component:   CallStatusEditorComponent,
        data:        {editor: 'edit'},
      },
    ],
  },
];

@NgModule({
  imports: [
    RouterModule.forChild(routes),
  ],
  exports: [
    RouterModule,
  ],
})

export class CallStatusRoutingModule {
}
